import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "vivion-container",
  ref: "container"
}
const _hoisted_2 = ["data-vin"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      className: "vivition-player",
      style: {"{\n                    background":"`url(https://static-api.vivition.com/carconnex_website/licenceplate_vin/_${vin}/initialphoto.jpg) no-repeat center / cover`"},
      "data-licenceplate": "",
      "data-vin": _ctx.vin,
      "data-theme": "carconnex_website"
    }, null, 8, _hoisted_2)
  ], 512))
}